// Engraving tool for Thomas Sabo PDP
// Migrated from Expanse v8 (temp/) to Expanse v9

(function () {
  function Engraving(container, type, jsonURL) {
    this.container = container;
    this.type = type === 'large-engraving' ? 'large' : 'small';
    this.engravingBtn = this.container.querySelector('.btn--engraving');
    this.engravingContainer = this.container.querySelector('.product-engraving');
    this.cancelEngravingBtn = this.engravingContainer.querySelector('.btn--cancel-engraving');
    this.engravingTools = this.engravingContainer.querySelector('.product-engraving__content');
    this.sectionTabs = this.engravingContainer.querySelector('.product-engraving__tabs');
    this.textPreview = this.engravingContainer.querySelector('.product-engraving__text');
    this.maxCharLimitEl = this.engravingContainer.querySelectorAll('[data-max-char-limit]');
    this.wordSlider = undefined;
    this.dateSeperator = '.';
    this.textInput = this.engravingContainer.querySelector('.engraving-text__input');
    this.allowedChars = this.textInput.maxLength;
    this.charCount = this.textInput.value.length;
    this.symbolLength = 1;
    this.addedSymbols = [];
    this.date = ['01', '01', '01'];
    this.activeLanguage = 'English';
    this.activeTheme = 'Cool Claims';
    this.languageJSON = {};

    if (type === 'large-engraving') {
      this.wordSlider = this.engravingTools.querySelector('.word-slider');
    }

    this.symbolSelector = this.container.querySelector('.engraving-symbols__categories');

    if (jsonURL != undefined && this.type === 'large') {
      this.fetchLanguageStrings(jsonURL);
    }

    var self = this;

    this.symbolSelector.addEventListener('change', function () {
      var selectedCategory = self.symbolSelector.selectedOptions[0].getAttribute('data-category');
      self.engravingContainer.querySelectorAll('.engraving-symbols__category-group').forEach(function (el) {
        el.classList.remove('active');
      });
      var activeGroup = self.engravingContainer.querySelector(
        '.engraving-symbols__category-group[data-category-group="' + selectedCategory + '"]'
      );
      if (activeGroup) {
        activeGroup.classList.add('active');
        new Flickity(activeGroup, {
          cellAlign: 'left',
          contain: true,
          setGallerySize: false,
          adaptiveHeight: true,
          imagesLoaded: true,
          lazyLoad: true,
          percentPosition: false,
          groupCells: '100%'
        });
      }
    });

    document.querySelector('.btn--add-engraving').addEventListener('click', function (evt) {
      evt.preventDefault();

      var engravingTextHiddenInput = document.querySelector('[data-properties-engraving-text]');
      var engravingHiddenInput = document.querySelector('[data-properties-engraving]');
      var fontHiddenInput = document.querySelector('[data-properties-font]');
      var fontSizeHiddenInput = document.querySelector('[data-properties-size]');
      var textPreview = document.querySelector('.engraving-text__input');
      var fontStyle = document.querySelector('.font-style__font--active');
      var fontSize = document.querySelector('.font-size__selector input:checked');

      if (engravingTextHiddenInput) {
        if (textPreview.value === '') {
          var errorEl = document.querySelector('.text-input .error');
          if (errorEl) errorEl.style.display = 'block';
          textPreview.focus();
          return;
        }
        var errorEl2 = document.querySelector('.text-input .error');
        if (errorEl2) errorEl2.style.display = 'none';

        engravingTextHiddenInput.value = textPreview.value;
        engravingHiddenInput.value = textPreview.value.split('').map(function (character) {
          var characterData = document.querySelector('[data-decimalvalue="' + character.charCodeAt(0) + '"]');
          if (characterData) {
            return '[' + characterData.dataset.egname.toUpperCase() + ']';
          }
          return character;
        }).join('');
      }

      if (fontHiddenInput && fontStyle) {
        fontHiddenInput.value = fontStyle.getAttribute('data-font-style');
      }

      if (fontSizeHiddenInput && fontSize) {
        fontSizeHiddenInput.value = fontSize.value;
      }

      self.closeEngravingTool();
      var addToCartBtn = document.querySelector('button.add-to-cart[type="submit"]');
      if (addToCartBtn) addToCartBtn.click();
    });

    this.engravingBtn.addEventListener('click', function (evt) {
      evt.preventDefault();
      self.openEngravingTool();
    });

    this.cancelEngravingBtn.addEventListener('click', function (evt) {
      evt.preventDefault();
      self.closeEngravingTool();
    });

    this.engravingContainer.querySelectorAll('.product-engraving__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.switchTab(this.dataset.tabTrigger);
      });
    });

    this.updateCharLimit();

    this.engravingTools.querySelectorAll('.font-style__font').forEach(function (fontBlock) {
      fontBlock.addEventListener('click', function () {
        document.querySelector('.font-style__font--active').classList.remove('font-style__font--active');
        this.classList.add('font-style__font--active');
        self.changeFont(this.dataset.fontStyle.toLowerCase());
        self.updateCharLimit();
      });
    });

    this.engravingTools.querySelectorAll('.font-size__selector input').forEach(function (selector) {
      selector.addEventListener('click', function () {
        self.switchFontSize(this.value);
        self.updateCharLimit();
      });
    });

    this.engravingTools.querySelectorAll('.engraving-text__input').forEach(function (textInput) {
      textInput.addEventListener('keydown', function (evt) {
        if (evt.keyCode !== 8 && self.charCount >= self.allowedChars) {
          evt.preventDefault();
        }
      });
      textInput.addEventListener('keyup', function () {
        self.changeText(this.value);
      });
    });

    if (this.type === 'large') {
      this.engravingTools.querySelector('.engraving-theme').addEventListener('change', function () {
        self.swapTheme(this.children[this.selectedIndex].value);
      });
      this.engravingTools.querySelector('.engraving-language').addEventListener('change', function () {
        self.swapLanguage(this.children[this.selectedIndex].value);
      });
      this.initialiseWordListener();
    }

    if (this.type === 'small') {
      this.engravingTools.querySelectorAll('.date-format').forEach(function (dateBlock) {
        dateBlock.addEventListener('click', function () {
          document.querySelector('.date-format--active').classList.remove('date-format--active');
          this.classList.add('date-format--active');
          self.changeDateFormat(this.dataset.format);
        });
      });

      this.engravingTools.querySelectorAll('.date-input').forEach(function (dateInput) {
        dateInput.addEventListener('keyup', function () {
          var dateType = 0;
          if (this.name === 'dateMonth') dateType = 1;
          else if (this.name === 'dateYear') dateType = 2;
          self.changeDate(this.value, dateType);
        });
      });
    }
  }

  Engraving.prototype.updateCharLimit = function () {
    var selectedFont = document.querySelector('.font-style__font.font-style__font--active');
    var textInput = document.querySelector('.engraving-tab--active .engraving-text__input');
    var largeFontEl = document.querySelector('[data-large-font]');
    var fontSizeElement = document.querySelector('[data-font-size-element]');

    if (selectedFont) {
      var smalCharLimit = selectedFont.getAttribute('data-char-small');
      var largeCharLimit = selectedFont.getAttribute('data-char-large');

      if (largeFontEl) {
        if (largeCharLimit) {
          largeFontEl.style.display = 'inline-block';
          largeFontEl.querySelector('input').disabled = false;
          if (fontSizeElement) fontSizeElement.style.display = 'flex';
        } else {
          largeFontEl.style.display = 'none';
          largeFontEl.querySelector('input').disabled = true;
          document.querySelector('[data-small-font] input').checked = true;
          if (fontSizeElement) fontSizeElement.style.display = 'none';
        }
      }

      var fontSizeEl = document.querySelector('.font-size__selector input:checked');
      if (fontSizeEl) {
        var fontSize = parseInt(fontSizeEl.getAttribute('data-font-size'));
        if (fontSize === 0 && smalCharLimit !== '') {
          this.allowedChars = parseInt(smalCharLimit);
          if (textInput) {
            textInput.maxLength = smalCharLimit;
            if (this.maxCharLimitEl) {
              this.maxCharLimitEl.forEach(function (el) { el.innerHTML = smalCharLimit; });
            }
          }
        }
        if (fontSize === 1 && largeCharLimit !== '') {
          this.allowedChars = parseInt(largeCharLimit);
          if (textInput) {
            textInput.maxLength = largeCharLimit;
            if (this.maxCharLimitEl) {
              this.maxCharLimitEl.forEach(function (el) { el.innerHTML = largeCharLimit; });
            }
          }
        }
        if (this.charCount > this.allowedChars && textInput) {
          textInput.value = '';
          this.changeText('');
        }
      }
    }
  };

  Engraving.prototype.fetchLanguageStrings = function (url) {
    var self = this;
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (response) {
        self.languageJSON = response;
        var languages = Object.keys(response);
        var themes = Object.keys(response['English']);
        var languageSelector = self.engravingContainer.querySelector('.engraving-language');
        var themeSelector = self.engravingContainer.querySelector('.engraving-theme');

        languageSelector.innerHTML = '';
        languages.forEach(function (lang) {
          languageSelector.innerHTML += '<option value="' + lang + '">' + lang + '</option>';
        });
        themeSelector.innerHTML = '';
        themes.forEach(function (theme) {
          themeSelector.innerHTML += '<option value="' + theme + '">' + theme + '</option>';
        });

        self.activeLanguage = languages[0];
        self.activeTheme = themes[0];
        self.wordSlider.innerHTML = '';
        self.languageJSON[self.activeLanguage][self.activeTheme].forEach(function (word) {
          var val = typeof word === 'object' ? word.engraved_text : word;
          var label = typeof word === 'object' ? word.display_text : word;
          self.wordSlider.innerHTML += '<div class="word-slider__word" data-value="' + val + '"><p>' + label + '</p></div>';
        });

        self.initialiseWordListener();
      });
  };

  Engraving.prototype.initialiseWordListener = function () {
    var self = this;
    if (!this.wordSlider) return;
    this.wordSlider.querySelectorAll('.word-slider__word').forEach(function (selector) {
      selector.addEventListener('click', function () {
        var word = this.dataset.value;
        self.changeText(word);
        self.engravingContainer.querySelectorAll('.engraving-text__input').forEach(function (input) {
          input.value = word;
        });
      });
    });
  };

  Engraving.prototype.openEngravingTool = function () {
    var self = this;
    this.engravingContainer.classList.add('product-engraving--open');
    document.documentElement.classList.add('modal-open');

    var linePropertiesContainer = document.querySelector('.engraving__line-properties');
    if (linePropertiesContainer) {
      linePropertiesContainer.innerHTML =
        '<input type="hidden" data-properties-engraving-text name="properties[Engraving Text]">' +
        '<input type="hidden" data-properties-engraving name="properties[Engraving Preview]">' +
        '<input type="hidden" data-properties-font name="properties[Font]">' +
        '<input type="hidden" data-properties-size name="properties[FontSize]">';
    }

    var firstGroup = this.container.querySelector('.engraving-symbols__category-group');
    if (firstGroup && !Flickity.data(firstGroup)) {
      var flkty = new Flickity(firstGroup, {
        cellAlign: 'left',
        contain: true,
        setGallerySize: false,
        adaptiveHeight: true,
        imagesLoaded: true,
        lazyLoad: true,
        percentPosition: false,
        groupCells: '100%'
      });
      flkty.resize();
    }

    this.checkTextLength();

    if (!this._symbolsInitialised) {
      this._symbolsInitialised = true;
      this.allSymbols = this.container.querySelectorAll('.engraving-symbol-button');
      this.engravingInputText = this.container.querySelector('.engraving-text__input');
      if (this.allSymbols) {
        this.symbolLength = parseInt(
          document.querySelector('.engraving-symbols__container').getAttribute('data-char-length')
        );
        this.allSymbols.forEach(function (symbol) {
          var dec = symbol.getAttribute('data-decimalvalue');
          if (dec) {
            var char = String.fromCharCode(parseInt(dec, 10));
            if (!symbol.textContent.trim()) symbol.textContent = char;
            if (!symbol.value) symbol.value = char;
          }
        });
        this.allSymbols.forEach(function (symbol) {
          symbol.addEventListener('click', function (evt) {
            evt.preventDefault();
            if (self.engravingInputText) {
              if (self.charCount + self.symbolLength > self.allowedChars) {
                self.checkTextLength();
                return;
              }
              self.charCount = self.charCount + self.symbolLength;
              self.addedSymbols.push(this.getAttribute('data-decimalvalue'));
              var inputValue = self.engravingInputText.value;
              var beforeSymbol = inputValue.slice(0, self.engravingInputText.selectionStart);
              var afterSymbol = inputValue.slice(self.engravingInputText.selectionStart, inputValue.length);
              var symbolChar = this.value || String.fromCharCode(this.getAttribute('data-decimalvalue'));
              self.engravingInputText.value = beforeSymbol + symbolChar + afterSymbol;
              self.changeText(self.engravingInputText.value);
            }
          });
        });
      }
    }
  };

  Engraving.prototype.closeEngravingTool = function () {
    this.engravingContainer.classList.remove('product-engraving--open');
    document.documentElement.classList.remove('modal-open');
  };

  Engraving.prototype.switchTab = function (tab) {
    this.sectionTabs.querySelector('.product-engraving__tab--active').classList.remove('product-engraving__tab--active');
    this.sectionTabs.querySelector('.product-engraving__tab[data-tab-trigger="' + tab + '"]').classList.add('product-engraving__tab--active');

    this.engravingTools.querySelector('.engraving-tab--active').classList.remove('engraving-tab--active');
    var tabContent = this.engravingTools.querySelector('.engraving-tab[data-tab="' + tab + '"]');
    tabContent.classList.add('engraving-tab--active');

    this.changeText();

    if (this.type === 'small') {
      if (tab === 'date') {
        this.textPreview.classList.add('font--small-date');
        this.changeDateFormat(this.dateSeperator);
      } else {
        this.textPreview.classList.remove('font--small-date');
        if (this.textInput.value.length === 0) {
          this.changeText('T&S');
        } else {
          this.changeText(this.textInput.value);
        }
      }
    }
    if (this.type === 'large') {
      this.changeText();
    }
  };

  Engraving.prototype.changeFont = function (fontStyle) {
    var textPreview = this.engravingContainer.querySelector('.product-engraving__preview .product-engraving__text');
    if (textPreview.classList.contains('font--block')) {
      textPreview.classList.replace('font--block', 'font--' + fontStyle);
    } else if (textPreview.classList.contains('font--script')) {
      textPreview.classList.replace('font--script', 'font--' + fontStyle);
    } else {
      textPreview.classList.replace('font--romantic', 'font--' + fontStyle);
    }
  };

  Engraving.prototype.switchFontSize = function (fontSize) {
    if (fontSize === '2mm') {
      this.textPreview.classList.replace('font--large', 'font--small');
    } else {
      this.textPreview.classList.replace('font--small', 'font--large');
    }
  };

  Engraving.prototype.changeText = function (textValue) {
    var self = this;

    if (!textValue && this.type === 'large') {
      var activeInput = this.engravingContainer.querySelector('.engraving-tab--active .engraving-text__input');
      if (activeInput) textValue = activeInput.value;
    }

    var previewLength = this.engravingContainer.querySelector('.engraving-tab--active .preview__length .length');

    if (!textValue) textValue = this.textInput.value;

    for (var j = 0; j < this.addedSymbols.length; j++) {
      var isDeleted = true;
      for (var i = 0; i < self.textInput.value.length; i++) {
        if (this.addedSymbols[j].includes(self.textInput.value.charCodeAt(i))) {
          isDeleted = false;
        }
      }
      if (isDeleted) {
        var index = self.addedSymbols.indexOf(this.addedSymbols[j]);
        if (index > -1) self.addedSymbols.splice(index, 1);
      }
    }

    if (previewLength) {
      if (textValue.length === 0) {
        this.charCount = 0;
        this.addedSymbols = [];
      } else {
        this.charCount = textValue.length - this.addedSymbols.length + this.addedSymbols.length * this.symbolLength;
      }
      this.checkTextLength();
      previewLength.innerText = this.charCount;
    }

    this.textPreview.innerText = textValue;
  };

  Engraving.prototype.checkTextLength = function () {
    var textInput = document.querySelector('.engraving-tab--active .engraving-text__input');
    var previewLengthEl = this.engravingContainer.querySelector('.engraving-tab--active .preview__length');
    if (textInput) {
      if (this.charCount >= textInput.maxLength) {
        if (previewLengthEl) previewLengthEl.classList.add('preview__length--error');
        return;
      }
      if (previewLengthEl && previewLengthEl.classList.contains('preview__length--error')) {
        previewLengthEl.classList.remove('preview__length--error');
      }
    }
  };

  Engraving.prototype.swapTheme = function (theme) {
    var textInput = document.querySelector('.engraving-tab--active .engraving-text__input');
    var words = this.languageJSON[this.activeLanguage][theme];
    var self = this;
    this.wordSlider.innerHTML = '';
    words.forEach(function (word) {
      var val = typeof word === 'object' ? word.engraved_text : word;
      var label = typeof word === 'object' ? word.display_text : word;
      if (val.length > textInput.maxLength) return;
      self.wordSlider.innerHTML += '<div class="word-slider__word" data-value="' + val + '"><p>' + label + '</p></div>';
    });
    this.initialiseWordListener();
  };

  Engraving.prototype.updateThemes = function (themes) {
    var themeSelector = this.engravingContainer.querySelector('.engraving-theme');
    themeSelector.innerHTML = '';
    themes.forEach(function (theme) {
      themeSelector.innerHTML += '<option value="' + theme + '">' + theme + '</option>';
    });
  };

  Engraving.prototype.swapLanguage = function (language) {
    this.activeLanguage = language;
    var themes = Object.keys(this.languageJSON[language]);
    var self = this;
    var words = this.languageJSON[language][themes[0]];
    this.wordSlider.innerHTML = '';
    this.updateThemes(themes);
    words.forEach(function (word) {
      var val = typeof word === 'object' ? word.engraved_text : word;
      var label = typeof word === 'object' ? word.display_text : word;
      self.wordSlider.innerHTML += '<div class="word-slider__word" data-value="' + val + '"><p>' + label + '</p></div>';
    });
    this.initialiseWordListener();
  };

  Engraving.prototype.changeDateFormat = function (seperator) {
    if (seperator) {
      this.dateSeperator = seperator;
      this.engravingTools.querySelectorAll('.date-seperator').forEach(function (el) {
        el.innerText = seperator;
      });
    }
    this.textPreview.innerText = this.date.join(this.dateSeperator);
  };

  Engraving.prototype.changeDate = function (date, type) {
    this.date[type] = date;
    this.textPreview.innerText = this.date.join(this.dateSeperator);
    this.textInput.value = this.date.join(this.dateSeperator);
  };

  window.Engraving = Engraving;
})();
